import { TBlockData } from '@internal/blocks/TBlockData';

export const getPrefetchBlockPropsKey = (blockData: TBlockData) =>
    `${blockData.type}-${blockData.id}`;
